import Skeleton from "react-loading-skeleton";


const InputFile = ({ onChange, loading, fileName, accept, name }) => {
    return (
        <>
            {loading ? <Skeleton className="w-full rounded py-3 px-5 text-xl" />
                :
                <div className="flex items-center truncate rounded-lg">
                    <label htmlFor={name ? name : "input-file"} className="bg-turquesa text-sm hover:opacity-90 text-white font-medium py-[9px] px-5 rounded-l cursor-pointer bg-Turquesa border-[1.5px]">
                        Subir
                    </label>
                    <input id={name ? name : "input-file"} type="file" className="hidden" onChange={onChange} accept={accept ? accept : "image/*"} />
                    <div className="border bg-transparent border-y-[1.5px] border-r-[1.5px] w-full rounded-r truncate">
                        <div className='py-[7px] !max-w-xs truncate'>
                            <span id="file-name" className="text-gray-700 dark:text-gray-200 text-sm !max-w-xs pl-2">
                                {
                                    fileName != "" && fileName != undefined && fileName != null
                                        ? fileName
                                        : 'Ningún archivo seleccionado'
                                }
                            </span>
                        </div>
                    </div>
                </div>}
        </>
    );
};

export default InputFile;